import React from 'react';
import classnames from 'classnames';
import SelectComponent from 'shared/components/SelectComponent';

const defaultOptions = [
  { value: '6 mm', text: '6 mm' },
  { value: '8 mm', text: '8mm' },
  { value: '12 mm', text: '12 mm' },
];

const MaterialThickness = (props) => {
  const {
    onChangeParameter,
    onChange: onChangeProp,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className
  } = props;

  const name = 'carrier_thickness';
  const onChange = onChangeProp || (e => onChangeParameter(name, e.target.value));

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('material-type', className)} />
  );
};

MaterialThickness.defaultProps = {
  options: defaultOptions,
  label: 'Material Thickness',
  required: true,
};

export default MaterialThickness;
